"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BANKRUPTCY_TIMELINE = exports.FEELING_341_MEETING = exports.SAY_TO_OTHERS_CONSIDERING = exports.PLANS_REBUILD_CREDIT = exports.FEELING_AFTER_FILING = exports.FRESH_START = exports.BEFORE_BANKRUPTCY = exports.HOPES_AND_DREAMS = exports.MOTIVATION = void 0;
exports.MOTIVATION = "motivation"; // What are your motivations for filing for bankruptcy?

exports.HOPES_AND_DREAMS = "hopes_and_dreams"; // What are your hopes and dreams for life without debt?

exports.BEFORE_BANKRUPTCY = "before_bankruptcy"; // Before bankruptcy, what else did you try to overcome your debt?

exports.FRESH_START = "fresh_start"; // What changes do you plan to make to your life when you get a fresh start?

exports.FEELING_AFTER_FILING = "feeling_after_filing"; // How are you feeling after filing bankruptcy?

exports.PLANS_REBUILD_CREDIT = "plans_rebuild_credit"; // What are your plans to rebuild credit after bankruptcy?

exports.SAY_TO_OTHERS_CONSIDERING = "say_to_others_considering"; // What would you say to Upsolve users considering bankruptcy?

exports.FEELING_341_MEETING = "feeling_341_meeting"; // What was your 341 meeting like?

exports.BANKRUPTCY_TIMELINE = "bankruptcy_timeline"; // What was your bankruptcy timeline?